var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { getFormatedDate, isAvalidDate, getDateValues, dateInputMask, } from '../DateField.utils';
var EMappedInputEventCodes;
(function (EMappedInputEventCodes) {
    EMappedInputEventCodes["BACKSPACE"] = "Backspace";
    EMappedInputEventCodes["ESC"] = "Escape";
})(EMappedInputEventCodes || (EMappedInputEventCodes = {}));
var DateFieldInput = function (_a) {
    var children = _a.children, closeCalendar = _a.closeCalendar, _b = _a.disableWeekend, disableWeekend = _b === void 0 ? false : _b, disabled = _a.disabled, maxDate = _a.maxDate, minDate = _a.minDate, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, openCalendar = _a.openCalendar, picker = _a.picker, _c = _a.range, range = _c === void 0 ? null : _c, readOnly = _a.readOnly, _d = _a.selected, selected = _d === void 0 ? null : _d, selectsRange = _a.selectsRange;
    var startDateInputRef = useRef(null);
    var endDateInputRef = useRef(null);
    var onStartDateInputChange = function (newValue) {
        if (isAvalidDate(newValue, disableWeekend, picker, minDate, maxDate)) {
            var _a = getDateValues(newValue, picker), day = _a.day, month = _a.month, year = _a.year;
            var date = new Date(year, month, day);
            if (selectsRange && range) {
                onChange([date, range[1]]);
                setTimeout(function () {
                    var _a;
                    (_a = endDateInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }, 100);
            }
            else {
                onChange(date);
                setTimeout(function () {
                    var _a;
                    (_a = startDateInputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                    closeCalendar();
                }, 100);
            }
        }
    };
    var onEndDateInputChange = function (newValue) {
        if (!range) {
            return;
        }
        if (isAvalidDate(newValue, disableWeekend, picker, range[0] || minDate, maxDate)) {
            var _a = getDateValues(newValue, picker), day = _a.day, month = _a.month, year = _a.year;
            var date = new Date(year, month, day);
            onChange([range[0], date]);
            setTimeout(function () {
                var _a;
                (_a = endDateInputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                closeCalendar();
            }, 100);
        }
    };
    var onStartDateInputBlur = function (e, startDateInputValue) {
        !!onBlur && onBlur(e);
        if (!isAvalidDate(startDateInputValue, disableWeekend, picker, minDate, maxDate)) {
            if (selectsRange && range) {
                onChange([null, range[1]]);
            }
            else {
                onChange(null);
            }
        }
    };
    var onEndDateInputBlur = function (e, inputValue) {
        !!onBlur && onBlur(e);
        if (!selectsRange || !range) {
            return;
        }
        if (!isAvalidDate(inputValue, disableWeekend, picker, range[0] || minDate, maxDate)) {
            if (selectsRange && range) {
                onChange([range[0], null]);
            }
        }
    };
    var onInputKeyDown = function (event, inputValue) {
        var _a;
        if (!Object.values(EMappedInputEventCodes).find(function (code) { return code === event.code; })) {
            return;
        }
        switch (event.code) {
            case EMappedInputEventCodes.ESC: {
                closeCalendar();
                return;
            }
            case EMappedInputEventCodes.BACKSPACE: {
                if (inputValue === '') {
                    (_a = startDateInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                return;
            }
            default: {
                return;
            }
        }
    };
    var getInputsWrapperClassName = function () {
        var classList = ['hefesto-datefield__input'];
        if (selectsRange && picker === 'month') {
            classList.push("hefesto-datefield__input--month-picker");
        }
        return classList.join(' ');
    };
    var inputsWrapperClassName = getInputsWrapperClassName();
    return (_jsxs("div", __assign({ className: inputsWrapperClassName }, { children: [_jsx(Input, { ref: startDateInputRef, name: "startdate", className: "start-date", date: selectsRange && range && range.length > 0 ? range[0] : selected, onKeyDown: function (e, inputValue) { return onInputKeyDown(e, inputValue); }, onFocus: function (e) {
                    openCalendar();
                    !!onFocus && onFocus(e);
                }, onBlur: function (e, inputValue) { return onStartDateInputBlur(e, inputValue); }, onChange: function (newValue) { return onStartDateInputChange(newValue); }, disabled: disabled, readOnly: readOnly, picker: picker }), selectsRange && (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "hefesto-datefield__separate-inputs", onClick: function () { var _a; return (_a = startDateInputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } }, { children: "-" })), _jsx(Input, { ref: endDateInputRef, name: "enddate", className: "end-date", date: range && range.length > 1 ? range[1] : null, onKeyDown: function (e, inputValue) { return onInputKeyDown(e, inputValue); }, onFocus: function (e) {
                            openCalendar();
                            !!onFocus && onFocus(e);
                        }, onBlur: function (e, inputValue) { return onEndDateInputBlur(e, inputValue); }, onChange: function (newValue) { return onEndDateInputChange(newValue); }, disabled: disabled, readOnly: readOnly, picker: picker })] })), children] })));
};
var Input = React.forwardRef(function (_a, ref) {
    var date = _a.date, className = _a.className, name = _a.name, picker = _a.picker, disabled = _a.disabled, readOnly = _a.readOnly, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown;
    var _b = useState(getFormatedDate(date, picker)), inputValue = _b[0], setInputValue = _b[1];
    var setDateInputValueIfNeed = function () {
        if (date !== null &&
            (inputValue === '' || inputValue !== getFormatedDate(date, picker))) {
            setInputValue(getFormatedDate(date, picker));
        }
        else if (date === null && inputValue !== '') {
            setInputValue('');
        }
    };
    useEffect(function () {
        setDateInputValueIfNeed();
    }, [date, onBlur]);
    return (_jsx("input", { ref: ref, name: name, className: className, autoComplete: "off", maxLength: picker === 'month' ? 7 : 10, placeholder: picker === 'month' ? 'mm/aaaa' : 'dd/mm/aaaa', value: inputValue, onKeyDown: function (e) { return onKeyDown(e, inputValue); }, onKeyPress: function (e) { return dateInputMask(e, inputValue, setInputValue, picker); }, onFocus: onFocus, onBlur: function (e) { return onBlur(e, inputValue); }, onChange: function (e) {
            setInputValue(e.target.value);
            onChange(e.target.value);
        }, disabled: disabled, readOnly: readOnly }));
});
Input.displayName = 'Input';
export default DateFieldInput;
